"use strict";

module.exports = {
  'name': 'coth',
  'category': 'Trigonometry',
  'syntax': ['coth(x)'],
  'description': 'Compute the hyperbolic cotangent of x in radians.',
  'examples': ['coth(2)', '1 / tanh(2)'],
  'seealso': ['sech', 'csch', 'tanh']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/coth.js
// module id = 969
// module chunks = 0